<input
  #file
  type="file"
  accept="image/jpeg, image/png"
  name="name"
  style="display: none"
  (change)="handleFileOpenDialog($event)"
/>
<itl-image
  [title]="node.title"
  [description]="node.description"
  [required]="node.mandatory"
  (addImageButtonClicked)="addImage()"
  [buttonText]="'audit.node.image.scan'| translate"
>
  <div *ngFor="let image of images" class="node-image">
    <img
      [src]="image.dataPath ? convertDataPathToFileSrc(image.dataPath) : image.data"
      width="100"
      height="100"
      class="padding"
      style="margin: 5px"
    />
  </div>
</itl-image>
